import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MandiriStorage} from './mandiri.storage';
import {PermataStorage} from './permata.storage';
import {BcaStorage} from './bca.storage';
import {OvoStorage} from './ovo.storage';
import {BriSyariahStorage} from './bri-syariah.storage';
import {DokuVaStorage} from './doku-va.storage';
import {DanamonStorage} from './danamon.storage';
import {paymentVaStorage} from './payment-va.storage';
import { BniStorage } from './bni.storage';
import { BncStorage } from './bnc.storage';
import { LinkajaStorage } from './linkaja.storage';


@NgModule({
    providers: [
        CommonModule,
        MandiriStorage,
        PermataStorage,
        BcaStorage,
        OvoStorage,
        BriSyariahStorage,
        DokuVaStorage,
        DanamonStorage,
        paymentVaStorage,
        BniStorage,
        BncStorage,
        LinkajaStorage
    ]
})
export class StorageModule {
}
